// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"32":"misc","328":"admin","601":"work","676":"message","809":"account","983":"report"}[chunkId] + "." + {"32":"5b2272f4","328":"6b78a25b","601":"5e05b383","676":"6141ba46","809":"cbaf782d","983":"cbbdde56"}[chunkId] + ".css";
};